import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import { useLang } from '@/i18n';

const Recall = () => {
    const { t } = useLang('recall');
    return (
        <div className={`${css.page}`}>
            <h1 className="recall-page-title">{t('title')}</h1>
            <A />
            <B />
        </div>
    );
};
export default Recall;
